export const IS_MAC = navigator.platform.startsWith('Mac');
export const CTRL_KEY = IS_MAC ? 'metaKey' : 'ctrlKey'; // 用于 Ctrl+C 这种复制操作
export const CTRL_KEY_LABEL = IS_MAC ? '⌘' : 'Ctrl';
export const CSS_PRIORITY_HACK_PREFIX = ['&.uc-component-wrapper.uc-component-wrapper.uc-component-wrapper', '.uc-component-wrapper.uc-component-wrapper.uc-component-wrapper &', '&'].join(', ');
export const DND_TYPE_DATA_PATH = 'uicore:data-path';
export const DND_TYPE_LAYOUT = 'uicore:comp';
export const DEFAULT_INLINE_STYLE_PROPS = ['+width', '+height'];
export const AUTO_COMPONENT_ID_PREFIX = '_uc_'; // 组件缺少 componentId 时需要自动补全
// eslint-disable-next-line @typescript-eslint/naming-convention
export const NO_OP = () => void 0;
export const TRANSPARENT_IMAGE = document.createElement('img');
TRANSPARENT_IMAGE.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
export const INJECT_UICORE_BUS = 'uicore:bus';
export const INJECT_UICORE_DESIGNER = 'uicore:designer';
export const INJECT_UICORE_RENDERER = 'uicore:renderer';
export const INJECT_UICORE_FORM = 'uicore:form';
export const INJECT_UICORE_FORM_GET_OVERRIDE_PROPS = 'uicore:form-get-override-props'; // () => ({ readonly: boolean })
export const INJECT_UICORE_COMPONENT_HOST = 'uicore:component-host';
export const INJECT_PROPPANEL_RUNEXPR = 'uicore:prop-panel-run-expr';
export const INJECT_SKELETON_CTX = 'uicore:skeCtx';
export const INJECT_UICORE_AICONTEXT = 'uicoreAiContext';
export const SELECTOR_DESIGNER_INTERACTIVE_ELEMENT = '[uc-designer-interactive], [uc-designer-interactive] *';
export const SELECTOR_DESIGNER_INTERACTIVE_DROPZONE_ELEMENT = '[uc-designer-interactive-dropzone], [uc-designer-interactive-dropzone] *';
export const FIT_DATA_TYPE_META = {
  editor: {
    name: '推荐的组件',
    order: 0
  },
  action: {
    name: '推荐的按钮',
    order: 1
  },
  'editor-alt': {
    name: '其他组件',
    order: 2
  },
  'action-alt': {
    name: '其他按钮',
    order: 3
  },
  display: {
    name: '展示型组件',
    order: 4
  }
};
export const DEFAULT_EDITORS_FIT_DATA_ORDER = 1000;
/** form中表示拒绝继承上级的配置 强行置于false */
export const FORM_OVERRIDE_FORCE_FALSE_VALUE = 'force false';
/** 这些伪元素选择器直接展示就行了 无需再append到element本身的选择器上进行预览 */
export const PSEUDO_PREVIEW_BLACKLIST = ['&:after', '&::after', '&:before', '&::before', '&::before', '&::first-letter', '&::first-line', '&::marker', '&::placeholder', '&::selection', '&::-webkit-scrollbar', '&::-webkit-scrollbar-button', '&::-webkit-scrollbar-thumb', '&::-webkit-scrollbar-track', '&::-webkit-scrollbar-track-piece', '&::-webkit-scrollbar-corner', '&::-webkit-resizer'];
// 小于这个高度的组件 actbar显示不下的时候会放下面
export const ACTIONBAR_IN_BOTTOM_MAX_HEIGHT = 400;
//# sourceMappingURL=consts.js.map
